import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { baseUrl } from './api-config';
import { Estensione } from '../models/estensione';
import { ResourcefulService } from './resourcefulService';
import { map, takeUntil } from 'rxjs/operators';


export class EstensioneData {
  updated: boolean;
  created: boolean;
};

export class InvioIncaricoData {
  code: number;
  message: String;
}

@Injectable({
  providedIn: 'root'
})
export class EstensioneService extends ResourcefulService<Estensione> {

  constructor(private httpClient: HttpClient) {
    super(httpClient, Estensione);
  }
  saveOrUpdate(searchParams = {}, slug: string): Promise<EstensioneData> {
    return this._httpClient.post<EstensioneData>(`${baseUrl}/estensioni/${slug}/salva`, searchParams
  ).toPromise();
  }

  inviaIncarico(idIncarico: number, params = {}): Promise<InvioIncaricoData> {
    console.log(params);
    return this._httpClient.post<InvioIncaricoData>(`${baseUrl}/estensioni/invia/${idIncarico}`, params).toPromise();
  }

  async bySlug(slug: string): Promise<Estensione> {
    try {
      return await this._httpClient.get<Estensione>(`${baseUrl}/${this.modelClass.apiUrl}/${slug}`)
      .pipe(
        map(response => new Estensione().deserialize(response))
      ).toPromise();
    } catch (error) {
      if ((error as HttpErrorResponse)?.status === 404) {
        const fallback = new Estensione();
        fallback.slug = slug;
        fallback.enabled = false;
        fallback.configuration = null;
        return fallback;
      }
      throw error;
    }
  }

  getExternalAssignmentExists(claim_number: string): Promise<boolean> {
    return this._httpClient.get<boolean>(`${baseUrl}/estensioni/${claim_number}/checkIfExists`).toPromise();
  }

  retrieveTablesFromGenerali(data): Promise<any>{
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/getTables`).toPromise();
  }

  retrieveTablesFromGeneraliWithParams(data): Promise<any>{
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/getTablesWithParams`, data).toPromise();
  }

  retrieveAllTables(): Promise<any> {
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/getTablesWithParamsAll`).toPromise();
  }

  saveGeneraliData(numero_sinistro: String, data: {}): Promise<boolean> {
    return this._httpClient.post<boolean>(`${baseUrl}/estensioni/generali/saveGeneraliData`, {data: data, numero_sinistro: numero_sinistro}).toPromise();
  }

  retrievePayload(numero_sinistro: String): Promise<any> {
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/${numero_sinistro}/payload`).toPromise();
  }

 /* retrieveData(numero_sinistro: String): Promise<any> {
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/${numero_sinistro}/data`).toPromise();
  }*/

  retrieveData(numero_sinistro: String): Promise<any> {
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/${numero_sinistro}/data`).toPromise();
  }

  retrieveMetadata(numero_sinistro: String): Promise<any> {
    return this._httpClient.get<any>(`${baseUrl}/estensioni/generali/${numero_sinistro}/metadata`).toPromise();
  }
}
